module.exports = __webpack_public_path__ + "img/9.540d1b73.jpg";